export default function LoadingComponent() {
    return <div className="loader flex items-center justify-center">
        <div className="loaderlogo"></div>
    </div>;
}


